import { render } from "./Rights.vue?vue&type=template&id=0c5bfc4a&scoped=true"
import script from "./Rights.vue?vue&type=script&lang=js"
export * from "./Rights.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0c5bfc4a"

export default script